import React, { Component } from 'react';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import Paper from 'material-ui/Paper';
import AppStore from '../../stores/app-store.js'
//import MenuItens from '../menuitens/MenuItens';

import { deepOrange500 } from 'material-ui/styles/colors';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import './MinhasHistorias.css';

const muiTheme = getMuiTheme({
	palette: {
		accent1Color: deepOrange500,
	},
});


class MinhasHistorias extends Component {
	constructor() {
		super();
		this.guardados = [];
		this.linhas = [];
		this.state = {
			menu: true,
			legendas: AppStore.legendas,
		}
		this.pegaHistoria = this.pegaHistoria.bind(this);
		this.onChangeLingua = this.onChangeLingua.bind(this);
		this.mostraMenu = true;
	}

	componentWillMount() {
		let tmp = localStorage.getItem("vdv_guardados");
		if (tmp) {
			this.guardados = tmp.split(",");
		}
		AppStore.addChangeLinguaListener(this.onChangeLingua);
	}

	componentWillUnmount() {
		AppStore.removeChangeLinguaListener(this.onChangeLingua);
	}


	onChangeLingua() {
		this.setState({
			legendas: AppStore.legendas,
		})
	}


	pegaHistoria(titulo) {
		this.setState({
			menu: false,
		});
		this.mostraMenu = false;
		let tmp = localStorage.getItem(titulo);
		this.linhas = tmp.split(",");
	}


	render() {
		if (this.mostraMenu) {
			return (
				<MuiThemeProvider muiTheme={muiTheme}>
					<div className="MinhasHistorias">
						<Paper>
							<Menu desktop={true}>
								{this.guardados.map((titulo) => <MenuItem primaryText={titulo} onTouchTap={()=>this.pegaHistoria(titulo)}/>)}
							</Menu>
						</Paper>
					</div>
				</MuiThemeProvider>
			);
		} else {
			this.mostraMenu = true;
			return (
				<MuiThemeProvider muiTheme={muiTheme}>
					<div className="MinhasHistorias">
						<Paper>
							{this.linhas.map(function (paragrafo) {
								return <p>{paragrafo + '.'}</p>
							})}
						</Paper>
					</div>
				</MuiThemeProvider>
			)
		}
	}
}

export default MinhasHistorias;


// WEBPACK FOOTER //
// ./src/componentes/minhashistorias/MinhasHistorias.js